<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Municípios
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Visualize os municípios disponíveis e acesse os servidores cadastrados.
          Utilize a busca para encontrar municípios de forma eficiente.
        </p>
      </div>
    </div>

    <form #municipioForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="municipio" style="font-size: 14px">Município</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="municipio"
                  class="form-control"
                  [(ngModel)]="filterMunicipio"
                  name="municipio"
                  placeholder="Digite o nome do município"
                  (keyup.enter)="applyFilters()"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </form>
    
    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="clearFilters()"
        >
          Limpar filtros
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary mb-2 mb-md-0"
          (click)="applyFilters()"
        >
          Pesquisar <i class="fa fa-search mr-1"></i>
        </button>
      </div>
    </div>
    <hr />
  </div>
</div>

<div class="card" style="border-radius: 10px">
  <table class="table text-center table-striped" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Município
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('usuarios')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Usuários
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('usuarios')" class="fa fa-caret-up"></i>
              <i
                *ngIf="!isColumnSorted('usuarios')"
                class="fa fa-caret-down"
              ></i>
              <i
                *ngIf="isColumnSorted('usuarios')"
                class="fa"
                [ngClass]="getSortIcon('usuarios')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('orgaos')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Órgãos
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('orgaos')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('orgaos')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('orgaos')"
                class="fa"
                [ngClass]="getSortIcon('orgaos')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('status')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Status
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('status')"
                class="fa"
                [ngClass]="getSortIcon('status')"
              ></i>
            </div>
          </div>
        </th>
        <th>
          <div class="d-flex align-items-center justify-content-center">Ações</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let cidade of cidadesData">
        <td class="pl-3 pr-3 align-middle">
          <div
            class="d-flex align-items-center justify-content-center texto-linha-tabela"
          >
            <i class="ft-building mr-2" style="color: #4e7977;"></i>
            {{ cidade.nome }}
          </div>
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ cidade.quantidade_usuarios }}
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ cidade.quantidade_orgaos }}
        </td>
        <td class="text-center align-middle">
          <span
            class="status-cidade"
            [ngClass]="getStatusClass(cidade)"
          >
            {{ getStatusCidade(cidade) }}
          </span>
        </td>
        <td class="d-flex justify-content-center align-items-center">
          <button
            type="button"
            (click)="goToServidores(cidade.id)"
            class="btn btn-outline-primary action-btn btn-square"
            title="Visualizar Servidores"
          >
            <i class="fa fa-eye"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="form-row" *ngIf="cidadesTotal > 0" style="padding: 0px 20px">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div>
         Exibindo {{(cidadesPage-1) * cidadesPageSize + 1}} a {{Math.min(cidadesPage * cidadesPageSize, cidadesTotal)}} de {{cidadesTotal}} itens
      </div>
      <div class="d-flex justify-content-center">
        <ngb-pagination
        class="ml-auto pagination-square"
        style="margin-top: 10px; margin-right: 10px"
        *ngIf="cidadesTotal > 0"
        [(page)]="cidadesPage"
        [pageSize]="cidadesPageSize"
        [maxSize]="3"
        [rotate]="true"
        [boundaryLinks]="true"
        size="sm"
        [collectionSize]="cidadesTotal"
        (pageChange)="onCidadesPageChange($event)"
      ></ngb-pagination>
      </div>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
